export enum IdleDialogActionType {
  Logout = 'logout',
  Continue = 'continue',
}
